export default "__VITE_ASSET__68ecf65f__"